module.exports = __webpack_public_path__ + "assets/svg/Icons/32/pending-yellow-3465c0.svg";